import { z } from 'zod';

export const LOGIN_FORM_SCHEMA = z.object({
  userName: z
    .string()
    .min(1, { message: 'Email is required' })
    .email({ message: 'Enter a valid email' }),
  password: z.string().min(1, { message: 'Password is required' }),
  rememberMe: z.boolean().default(true),
  isZendesk: z.boolean().default(false)
});

export const DEFAULT_VALUES = {
  userName: '',
  password: '',
  rememberMe: true,
  isZendesk: false
};

export type LoginFormData = z.infer<typeof LOGIN_FORM_SCHEMA>;

export const ZENDESK_DOMAIN = 'publishers.appcharge.com';